export default () => {
	jQuery( "#mobile-menu-toggle").on("click", function() {
		const el = jQuery('#mobile-menu-container');
		if(el.is(':hidden')) {
			el.slideDown()
		} else {
			el.slideUp()
		}
	})

	jQuery('div[id^="menu-item-"]').each( function(i) {
		const id = jQuery(this).attr('data-id');
		const submenu = jQuery('#submenu-item-'+id)
		const submenuIcon = jQuery('#submenu-icon-'+id)
		jQuery(this).on("click", function() {
			if(submenu.is(':hidden')) {
				submenuIcon.addClass('rotate-45')
				submenu.slideDown()
			} else {
				submenu.slideUp()
				submenuIcon.removeClass("rotate-45")
			}
		})
		
	});

	let sideContainer = jQuery('#side-container');
	jQuery( "#side-menu-toggle" ).on("click", function(e) {
		if(!sideContainer.hasClass('open')) {
			sideContainer.addClass('open')
		}
	})

	jQuery( "#side-menu-backdrop" ).on("click", function(e) {
		if(sideContainer.hasClass('open')) {
			sideContainer.removeClass('open')
		}
	})


}